import { addVoucher } from "../../../app/api/manageVoucher";
import { BaseAction } from "../../../core/actions/BaseAction";
import { toAddVoucherErrorKey } from "../../../Lib/Utils/voucherErrors";
import { IAddVoucherActionParams, IAddVoucherResult } from "../../../Orchestrator/Types/Interface/ActionParams/VoucherActionParams";
import { fetchVouchersAction } from "./FetchVouchersAction";

export class AddVoucherAction extends BaseAction<IAddVoucherResult, IAddVoucherActionParams> {
    override async run(): Promise<IAddVoucherResult> {
        const { userId, voucherCode } = this.params!
        const response = await addVoucher(userId, voucherCode);
        if (response.status !== "ok") {
            return { errorKey: toAddVoucherErrorKey(response) };
        }
        fetchVouchersAction.setParams({ userId });
        await fetchVouchersAction.execute();
        return {};
    }
}
export const addVoucherAction = new AddVoucherAction();
